// El saldo de la empresa, para los guards de las herramientas del lienzo —
// ADR-2026-09-16-las-herramientas-del-lienzo-abren-en-panel.
//
// La misma consulta que hacen el visor y los modos antes de cobrar (plan y créditos
// restantes), una sola vez acá en vez de una copia por panel. `restantes` en `null`
// significa que no se pudo saber: los guards dejan pasar, y es el backend el que cobra
// o rechaza (así funciona en el visor: "subscription check failed, allow anyway").

import { supabase } from '../../../lib/supabase';

export interface Saldo {
  plan: string | null;
  restantes: number | null;
}

export type TipoDeLimite = 'free-trial-ended' | 'plan-limit-reached';

export async function consultarSaldo(companyId: string): Promise<Saldo> {
  try {
    const { data } = await supabase
      .from('company_profiles')
      .select('plan, imagenes_restantes:imagenes_disponibles')
      .eq('id_company', companyId)
      .single();
    const d = data as { plan?: string | null; imagenes_restantes?: number | null } | null;
    return {
      plan: d?.plan ?? null,
      restantes: typeof d?.imagenes_restantes === 'number' ? d.imagenes_restantes : null,
    };
  } catch {
    return { plan: null, restantes: null };
  }
}

/** Qué modal de límite corresponde: el del plan gratis, o el de tope de plan. */
export const tipoDeLimite = (plan: string | null | undefined): TipoDeLimite =>
  plan === 'gratis' ? 'free-trial-ended' : 'plan-limit-reached';
